import { render, staticRenderFns } from "./EffDate.vue?vue&type=template&id=2c44648f&scoped=true"
import script from "./EffDate.vue?vue&type=script&lang=js"
export * from "./EffDate.vue?vue&type=script&lang=js"
import style0 from "./EffDate.vue?vue&type=style&index=0&id=2c44648f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44648f",
  null
  
)

export default component.exports